import { fetchExperimentEditVariantQuery } from 'api/queries/experiments';
import { OriginalExperimentState } from 'modules/experiments/takeover/types';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { useGraphql } from 'utils/hooks/useGraphql';
import { useExperimentsTranslations } from './useTranslations';

type ExperimentTakeoverVariantListRequest = {
  id: number;
  locale?: string;
};

type ExperimentTakeoverVariantListResponse = {
  experiment: {
    variations: OriginalExperimentState['variations'];
  };
};

export const useExperimentTakeoverVariantList = (experimentId: number, locale: string) => {
  const { t } = useExperimentsTranslations();
  const dispatch = useDispatch();
  const { refetch } = useGraphql<
    ExperimentTakeoverVariantListResponse,
    ExperimentTakeoverVariantListRequest
  >(fetchExperimentEditVariantQuery, {
    variables: {
      id: experimentId,
      locale,
    },
    skip: true,
  });

  return async () => {
    const {
      data: { experiment },
      error: refetchError,
    } = await refetch({
      id: experimentId,
    });

    if (refetchError) {
      dispatch(
        addNegativeToastWithErrorId(
          t('errorMessage.fetchExperimentTakeoverVariantList'),
          'reFetchVariantList',
          refetchError,
          { experimentId },
        ),
      );
    }

    return experiment?.variations ?? [];
  };
};
